import * as ss from 'superstruct';
import { GoogleAdsCustomerId } from '../../tracking/ad-account-id';

/**
 * The configuration for sending conversions to Google Ads via the
 * Google Data Manager API.
 *
 * https://developers.google.com/data-manager/api
 */
export const GoogleAdsDataManagerOutputStreamDestination = ss.type({
  name: ss.literal('google-ads-data-manager'),
  /**
   * Numeric conversion action ID. Should NOT include the
   * `customers/X/conversionActions/` resource-name prefix.
   */
  conversionActionId: ss.string(),
  /**
   * If we should send any identifying info in the conversion
   * (email, phone).
   */
  enhanced: ss.boolean(),
  /**
   * Operating account: the Google Ads customer ID that owns the
   * conversion action. Stored as 10 digits, without dashes.
   */
  customerId: GoogleAdsCustomerId,
});

export type GoogleAdsDataManagerOutputStreamDestination = ss.Infer<
  typeof GoogleAdsDataManagerOutputStreamDestination
>;
